import { SpaceVertical, type SpaceVerticalProps } from '@looker/components';
import type { IconName } from '@pulsepointinc/bi-components';
import { BIIcon, globalTheme } from '@pulsepointinc/bi-components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import type React from 'react';
import styled from 'styled-components';

import { PUBLIC_ASSETS_BUCKET_URL } from '../helpers';

interface NoDataDashboardProps extends SpaceVerticalProps {
  message?: string;
  icon?: IconName;
  iconSize?: string | number;
  imgSrc?: string;
  height?: string;
  background?: string;
  children?: React.ReactNode;
}

export const NoDataDashboard: React.FC<NoDataDashboardProps> = ({
  message = 'There is no data for this line item.',
  icon,
  iconSize = 128,
  imgSrc = `${PUBLIC_ASSETS_BUCKET_URL}cowPointingUp.svg`,
  height = '100vh',
  pt = '120px',
  background = globalTheme.colors.white,

  gap = 'none',
  justify = 'start',
  align = 'center',
  children,
  ...props
}) => (
  <Container gap={gap} align={align} justify={justify} height={height} pt={pt} background={background} {...props}>
    {icon ? (
      <BIIcon icon={icon as IconName} size={iconSize} />
    ) : (
      <PlaceholderImage src={imgSrc} alt="No data illustration" />
    )}

    <SpaceVertical gap="none" align="center">
      <DsTypography color="secondary">{message}</DsTypography>
      {children}
    </SpaceVertical>
  </Container>
);

const Container = styled(SpaceVertical)<{
  height: string;
  background: string;
}>`
  width: 100%;
  height: ${({ height }) => height};
  background: ${({ background }) => background};
`;

const PlaceholderImage = styled.img`
  width: 120px;
  height: 170px;
  margin-bottom: 20px;
`;

export default NoDataDashboard;
